import { saveStudyApi, fetchAllStudyApi, updateStudyApi, getViewInvitesApi} from '../api/studyApi';
import {requestStarted,requestCompleted} from "./common"


export const setSaveStudyResponse =(studyResponse) => {
  return {
    type : "SET_STUDY_RESPONSE",
    studyResponse
  }
}

export const setUpdateStudyResponse =(studyResponse) => {
  return {
    type : "SET_UPDATE_STUDY_RESPONSE",
    studyResponse
  }
}

export const setStudyMsg =() => {
  return {
    type : "SET_STUDY_MSG_NULL"

  }
}

export const setStudyList =(data) => {
  return {
    type : "SET_STUDY_LIST",
    data
  }
}

export const setFailStudyList =(data) => {
  return {
    type : "SET_STUDY_LIST_FAIL",
    data
  }
}

export const editStudy =(data) => {
  return {
    type : "EDIT_STUDY",
    data
  }
}

export const setInvitesResponse = (data) =>{
  return {
    type : "SET_INVITES_DATA",
    data
  }
}


export const backInvites = () =>{
  return {
    type : "SET_OFF_INVITES_DATA",
    
  }
}

export const saveStudy=(studyData) =>{
  return dispatch =>{
      dispatch(requestStarted());
    saveStudyApi(studyData).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setSaveStudyResponse(result));
    });
  }
}

export const fetchAllStudy=(token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchAllStudyApi(token).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setStudyList(result));
        }
        else {
          dispatch(setFailStudyList(result));
        }
    });
  }
}

export const updateStudy=(studyData) =>{
  return dispatch =>{
      dispatch(requestStarted());
      updateStudyApi(studyData).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setUpdateStudyResponse(result));
    });
  }
}

export const getViewInvites=(studyData) =>{
  return dispatch =>{
      dispatch(requestStarted());
      getViewInvitesApi(studyData).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setInvitesResponse(result));
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/study.js